import React from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { getRelationshipLabel } from '../helpers/coverage-display-helpers';
import { CoveragePerson, RelationshipCode } from '../models/coverage-models';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { TcsmContentPropsState } from '../../../../../../global/models/epi-model';
import { RelationshipsProps } from '../../../../../account-info/models/account-info-epi-props';



interface Props {
	dependents: CoveragePerson[];
	settings: NewHireProps;
	editLink: JSX.Element;
}
export function CoverageReviewDependent(props: Props) {
	const { dependents, settings, editLink } = props;
	const epiProps = useSelector<TcsmStates, TcsmContentPropsState<RelationshipsProps>>(state => state.epiProps?.relationshipsSettingState);
	const nonSpouseDependents = dependents?.filter(dep => dep?.relationship !== RelationshipCode.Spouse);

	return (
		<>
			<DividerSection sectionText={settings?.dependentSectionTitle} secondarySectionNode={editLink}>
				{
					nonSpouseDependents && nonSpouseDependents.length > 0 ?
						nonSpouseDependents?.map(dep =>
							<div className='divider-section-item' key={dep.guid}>

								<p>{`${dep?.first_name} ${dep?.middle_name} ${dep?.last_name}`}</p>
								<p className='input-caption'>{getRelationshipLabel(dep?.relationship, settings)} </p>
							</div>) 
							:
						<ContentSpacer>
							<div dangerouslySetInnerHTML={{ __html: epiProps.epiContent.noDependentsFoundMessage }} />
						</ContentSpacer>
				}
			</DividerSection>

		</>
	);
}